import { GatsbyBrowser } from 'gatsby';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

export const onClientEntry: GatsbyBrowser['onClientEntry'] = async () => {
  if (typeof fetch === 'undefined') {
    // @ts-ignore
    await import('whatwg-fetch');
    console.log('Fetch polyfill enabled');
  }
};
